import { t, Trans } from '@lingui/macro';
import { Button, Input } from '@mantine/core';
import { isNotEmpty, useForm } from '@mantine/form';
import { observer } from 'mobx-react-lite';
import { IMaskInput } from 'react-imask';
import { User } from 'tabler-icons-react';

type LoginForm = {
  onSubmit: ({ phone }: { phone: string }) => void;
};
export const LoginForm = observer(({ onSubmit }: LoginForm) => {
  const form = useForm({
    initialValues: {
      phone: '',
    },

    validate: {
      phone: isNotEmpty(t`Пожалуйста, заполните поле`),
    },
  });

  return (
    <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
      <Input.Wrapper
        label={<Trans>Номер телефона</Trans>}
        {...form.getInputProps('phone')}
      >
        <Input<any>
          size="lg"
          icon={<User size="1rem" />}
          component={IMaskInput}
          placeholder="374 01 234 567"
          mask="{374} 00 000 000"
          value={form.getInputProps('phone').value}
          onBlur={form.getInputProps('phone').onBlur}
          onFocus={form.getInputProps('phone').onFocus}
          error={form.getInputProps('phone').error}
          onAccept={(_: any, mask: { unmaskedValue: string }) => {
            form.getInputProps('phone').onChange(mask.unmaskedValue);
          }}
        />
      </Input.Wrapper>

      <Button size="lg" mt="lg" fullWidth type="submit">
        <Trans>Отправить код</Trans>
      </Button>
    </form>
  );
});

LoginForm.displayName = 'LoginForm';
